import React from "react";

export const FeaturesTransitions = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={56}
            height={57}
            viewBox="0 0 56 57"
            fill="none"
            {...props}
        >
            <path
                d="M8 18.887a8 8 0 018-8h10v35H16a8 8 0 01-8-8v-19z"
                fill="#32393E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25 6.526l7.633 4.361H41c3.864 0 7 3.162 7 7v22c0 3.84-3.203 7.045-7.065 7.045H32.6L25 50.141V6.526zm1 1.723v40.384l6.399-2.7h8.536c3.311 0 6.065-2.76 6.065-6.046v-22c0-3.288-2.69-6-6-6h-8.633L26 8.25z"
                fill="#32393E"
            />
            <path
                d="M42 28.833l-15-5.946 1.095 4.325v3.35L27 34.888l15-6.054z"
                fill="#FE9235"
            />
            <path d="M29 26.887H18v4h11v-4z" fill="#FE9235"/>
        </svg>
    )
}
